import React from "react";
import {
  gwsceBackground,
  gwsceLogo,
  gwscePattern,
} from "assets/assetReference";

const EventPage = () => {
  const whyAttend = [
    {
      title: "CONNECT",
      desc: "Connect with key supply chain leaders and influential decision-makers from the global wind industry",
    },
    {
      title: "ENJOY",
      desc: "Enjoy premium Chinese dishes and complimentary beverages",
    },
    {
      title: "EXPAND",
      desc: "Expand your network and uncover new business opportunities in an intimate, relaxed setting",
    },
    {
      title: "BENEFIT",
      desc: "Benefit from a convenient location within ExCeL London for easy conference access",
    },
  ];

  return (
    <div className="font-sans text-gray-800">
      {/* Hero Section */}
      <div className="relative h-[600px] text-white">
        <img
          src={gwsceBackground}
          alt="Event Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="bg-black bg-opacity-70 h-full flex flex-col justify-center items-center px-4 relative">
          <img src={gwsceLogo} className="h-10 mb-4" alt="gwsce logo" />
          {/* <h1 className="text-lg text-main-event-red font-semibold">
            Global Wind Supply Chain Exchange
          </h1> */}
          <div className="bg-main-event-red h-[2px] w-16"></div>
          {/* <h2 className="text-5xl leading-[1.2] font-headings font-bold mt-2 text-center"> */}
          <h1 className="text-5xl leading-[1.2] font-body-flex  mt-6 text-center">
            Exclusive Offshore Wind
            <br />
            Networking Event
          </h1>
          <div className="mt-6 text-center text-sm">
            <p>
              <strong>Date:</strong> Monday, 16 June 2025
            </p>
            <p>
              <strong>Time:</strong> 5:30 PM onwards
            </p>
            <p>
              <strong>Location:</strong> China Palace, 2 Western Gateway, London
              E16 1DR
            </p>
            <p>
              <strong>Cost:</strong> Complimentary (Invitation Only)
            </p>
          </div>
        </div>
      </div>

      {/* Overview Section */}
      <div className="bg-gray-100 py-12 px-6 md:px-16">
        <div className="max-w-4xl mx-auto">
          {/* <h3 className="text-sm uppercase text-gray-500 font-headings">
            What We Are
          </h3> */}
          <h2 className="text-3xl font-bold mt-1 font-body-condensed">
            Event Overview
          </h2>
          <p className="mt-4 text-gray-700">
            Join us for an exclusive evening of high-level networking on the eve
            of the London Global Offshore Wind conference. The Global Wind
            Supply Chain Exchange brings together senior executives from China’s
            offshore wind sector, leading European offshore wind developers,
            EPCI contractors, designers, and certification bodies — creating a
            unique opportunity to form meaningful connections in a refined
            setting.
          </p>
          <a
            href="https://eventshouse.net/gwsce-2025"
            target="_blank"
            rel="noreferrer noopener"
          >
            <button
              type="button"
              className="mt-6 px-6 py-3 bg-main-event text-white rounded hover:bg-gray-800"
            >
              REGISTER NOW
            </button>
          </a>
        </div>
      </div>

      {/* Why Attend Section */}
      <div className="py-12 px-6 md:px-16">
        {/* <h3 className="text-sm uppercase text-gray-500 font-headings">
          What We Offer
        </h3> */}
        <h2 className="text-3xl font-body-condensed font-bold mt-1">
          Why Attend?
        </h2>
        {/* <h2 className="text-3xl font-serif font-bold mt-1">Why Attend?</h2> */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
          {whyAttend.map((i) => {
            return (
              <div>
                <h4 className="text-xl mb-2 font-headings font-bold">
                  {i.title}
                </h4>
                <p>{i.desc}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Schedule Section */}
      <div className="bg-gray-100 py-12 px-6 md:px-16">
        <h3 className="text-sm uppercase text-gray-500 font-headings">
          Event Timetable
        </h3>
        <h2 className="text-3xl font-body-condensed font-bold mt-1">
          Schedule at a Glance
        </h2>
        <table className="mt-6 w-full text-left text-sm border-t border-gray-300 font-body">
          <tbody>
            <tr className="border-b border-gray-200">
              <td className="py-3 w-1/3">5:30 PM - 6:00 PM</td>
              <td className="py-3">Registration and Welcome Drinks</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-3">6:00 PM - 6:15 PM</td>
              <td className="py-3">Opening Remarks</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-3">6:15 PM - 7:30 PM</td>
              <td className="py-3">Networking and Buffet</td>
            </tr>
            <tr className="border-b border-gray-200">
              <td className="py-3">7:30 PM - 8:30 PM</td>
              <td className="py-3">Informal Discussions & Mingling</td>
            </tr>
            <tr>
              <td className="py-3">8:30 PM</td>
              <td className="py-3">Event Closes</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* CTA Section */}
      <div className="bg-main-event text-white flex relative max-h-[24rem]">
        <div className="max-w-4xl mx-auto py-12 px-6 md:px-16  w-[70%]">
          <h2 className="text-3xl font-body-condensed font-bold">
            Secure Your Spot
          </h2>
          <div className="font-body">
            <p className="mt-4">
              This invitation-only event is complimentary, but spaces are
              limited to maintain exclusivity.
            </p>
            <p className="mt-2">
              Please complete the registration form via the link below to
              reserve your place with EventsHouse.
            </p>
          </div>
          <a
            href="https://eventshouse.net/gwsce-2025"
            target="_blank"
            rel="noreferrer noopener"
          >
            <button
              type="button"
              className="font-headings mt-6 px-6 py-3 bg-main-event-red rounded hover:bg-red-700"
            >
              Register Now
            </button>
          </a>
        </div>
        <img
          src={gwscePattern}
          alt="pattern for deco"
          className="w-[30%] object-cover"
        />
      </div>
    </div>
  );
};

export default EventPage;
